export const RECRUITING_APPLY_URL =
  'https://salt2-cal-web-production.up.railway.app/apply/open';

export const BOOTCAMP_URL = 'https://events.salt-2.com/';

// 受付の状況は events.salt-2.com（event-lp/src/data/cohorts.ts・applicationCampaign.ts）が正本。
// 開催回が切り替わったら、ここも合わせて直す（日単位の日程はLPにだけ書く）。
export const BOOTCAMP_NOTICE = {
  href: BOOTCAMP_URL,
  title: 'NEXT BOOTCAMP — 12月〜1月の回を受付中',
  detail: '日程・募集要項を見る',
};

export const BOOTCAMP_PROGRAMS = [
  { name: 'AI駆動開発 Bootcamp', meta: '12月〜1月の回 受付中' },
  { name: 'AIコンサルティング Bootcamp', meta: '次回は未定' },
];

// 自社メディアの note と Zenn（ニュースの「自社メディア」と同じ。pages/News.jsx）。
// トップの構造化データで、会社と同じものとして紐づける（lib/structuredData.js）
export const OWN_MEDIA_URLS = ['https://note.com/salt2', 'https://zenn.dev/p/salt2'];
